import {

  CORE_LOAD_ACTIONS_REQUEST,
  CORE_LOAD_ACTIONS_SUCCESS,

} from '../../types'

const initialState = []
export default {
  actions: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ACTIONS_REQUEST:
        return initialState
      case CORE_LOAD_ACTIONS_SUCCESS:
        if (action.payload)
          return action.payload
        else return []
      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/features/action/reducer.js